import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Radio } from '@lusha-ui/radio';
import React from 'react';
function ScriptOption(props) {
    const { value, label, checked, onChange } = props;
    return (_jsx("div", { children: _jsx(Radio, { value: value, label: label, checked: checked, onChange: onChange }) }));
}
export default ScriptOption;
